import React, { useEffect, useState } from "react";
import CreditCardProp from "../components/CreditCardProp";
import DropDown2 from "../components/DropDown2";
import Button from "../components/Button";
import CardCreditOption from "../components/CardCreditOption";
import img from "../assets/creditimg.jpg";
import { Link, useParams, useLocation } from "react-router-dom";
import CardComparisonPage from "./Card Comparison/CardComparisonPage";
import { CircularProgress } from "@mui/material";
import PageSEO from "../components/SEO_Component/PageSEO";
import BreadcrumbNav from "../components/BreadcrumbNav";

const CreditCardOptionPage = () => {
  const { lang } = useParams();
  const [cashBackCreditCardData, setCashBackCreditCardData] = useState([]);
  const [data, setData] = useState([]);
  const [allCreditCards, setAllCreditCards] = useState([]);
  const [seo, setSEO] = useState({});
  const [navigations, setNavigation] = useState([]);

  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];

  const [isLoading, setIsLoading] = useState(true);

  window.scrollTo({
    top: 0,
    behavior: "instant",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}${lang}/credit-cards?debug=true`
        );
        const data = await response.json();
        setCashBackCreditCardData(data.sections.cashback.items);
        setSEO(data["seo"]);
        setNavigation(data.navigation);
        if (data && data.sections) {
          const sectionsArray = [];
          for (const sectionKey in data.sections) {
            const section = data.sections[sectionKey];
            sectionsArray.push(section);
          }
          setData(sectionsArray);
        }

        // collect all the card data
        const sections = data.sections;

        // Collect all credit card details
        let allCreditCards = [];

        for (const category in sections) {
          const categoryItems = sections[category].items;
          for (const item of categoryItems) {
            allCreditCards.push(item);
          }
        }

        setAllCreditCards(allCreditCards);

        setIsLoading(false);
      } catch (err) {
        console.log(err.message);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const getLastPartOfUrl = (url) => {
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}
      {!isLoading && (
        <div className=" rounded-[10px] flex flex-col">
          <PageSEO seoData={seo} />
          <BreadcrumbNav
            pathSegments={navigations.filter(
              (item) => item.id === "home" || item.id === `${lastSegment}`
            )}
          />
          <div className="flex  justify-center text-center mx-auto mt-4">
            <h1 className=" font-montserrat font-semibold text-2xl md:text-3xl leading-[29.26px] text-[#5C5A5A] mx-auto">
              {seo.h1}
            </h1>
          </div>
          <div className="items-center self-center my-4">
            <p className="self-center font-montserrat w-full font-semibold text-[14px] md:text-xl text-center md:mx-auto leading-[17.07px] text-[#5C5A5A]">
              {seo.title}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4 mx-6 md:w-[90vw] justify-center items-center md:grid-cols-4 md:gap-4 md:mx-20 md:px-20 md:mt-12 md:mb-5">
            {data.map((childId, index) => {
              return (
                <div className="w-full md:w-[100%] mx-auto md:mt-4" key={index}>
                  <Link
                    to={{
                      pathname: `/${lang}/credit-cards-category/${getLastPartOfUrl(
                        childId?.url
                      )}`,
                    }}
                  >
                    <CardCreditOption
                      key={index}
                      title={childId.heading}
                      img={img}
                      isBlue={true}
                      data={childId}
                    />
                  </Link>
                </div>
              );
            })}
          </div>

          <div className="flex  justify-center mt-10 ml-8 w-[85vw] md:w-full md:mt-20 text-center pt-5">
            <p className=" font-montserrat font-semibold text-[20px] md:text-[40px] leading-[26.38px] text-[#5C5A5A] md:text-center">
              Compare between different Credit Cards
            </p>
          </div>

          <CardComparisonPage creditCards={allCreditCards} />
          <div className="flex  justify-center  mt-10 w-[90vw] text-center mx-auto mb-1">
            <p className=" font-montserrat font-semibold text-[20px] md:text-[48px] md:mt-5 md:mb-5 leading-[24.38px] text-[#5C5A5A] mx-auto">
              Top Cashback Credit Cards
            </p>
          </div>

          <div className="flex flex-col items-center mb-10 ">
            <div className="md:grid md:grid-cols-3 md:gap-4 md:mt-4 md:mb-4 md:mx-3">
              <>
                {cashBackCreditCardData.map((item, index) => {
                  return (
                    <div className="mt-8 md:mt-10" key={index}>
                      <CreditCardProp
                        title={item.title}
                        img={item.image}
                        joining_fees={item.joining_fees}
                        renewal_fees={item.renewal_fees}
                        id={item.id}
                        apply={item.apply_link}
                      />
                    </div>
                  );
                })}
              </>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreditCardOptionPage;
